import React from "react";
import { useIntl } from "react-intl";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogActions, Grid } from "@material-ui/core";

import { useStyles } from "./detailStyles";
import translate from "../../../i18n/translate";
import { SrAlert, SrButton, SrInput } from "../../common";
import { SrDialogTitle } from "../../common/SrDialog";
import { validations } from "utils";

const validationSchema = Yup.object().shape({
  email: validations.email.required(translate("common.requiredField")),
});

const initialValues = {
  email: "",
};

const EmailDialog = ({ onClose, onSubmit, show, isSubmitting, error }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog open={show} onClose={onClose} fullWidth maxWidth="sm">
      <SrDialogTitle variant="subtitle1">
        {translate("resume.transactionDetails.form.title")}
      </SrDialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          errors,
          touched,
          values,
          isValid,
        }) => (
          <Form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                className={classes.dialogContent}
                spacing={2}
              >
                <Grid item xs={12}>
                  <SrInput
                    fullWidth
                    name="email"
                    value={values?.email}
                    error={Boolean(touched?.email && errors?.email)}
                    helperText={touched?.email && errors?.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder={intl.formatMessage({
                      id: "resume.transactionDetails.form.email",
                    })}
                  />
                </Grid>
                {error && (
                  <Grid item xs={12}>
                    <SrAlert severity="error">{error}</SrAlert>
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <SrButton variant="outlined" color="primary" onClick={onClose}>
                {translate("resume.transactionDetails.form.cancel")}
              </SrButton>
              <SrButton
                color="primary"
                type="submit"
                variant="contained"
                className={classes.buttonConfirm}
                disabled={!values.email || !isValid || isSubmitting}
              >
                {translate("resume.transactionDetails.form.confirm")}
              </SrButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

EmailDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default EmailDialog;
